(function ($) {
  function initBrandReviews(scope) {
    if (!$.fn.owlCarousel) {
      return;
    }

    var $scope = scope ? $(scope) : $(document);
    var $sections = $scope.filter('.brand-reviews').add($scope.find('.brand-reviews'));

    $sections.each(function () {
      var $section = $(this);
      var $carousel = $section.find('.owl-carousel');

      if (!$carousel.length || $carousel.hasClass('owl-loaded')) {
        return;
      }

      var $floatNav = $carousel.next('.float-nav');

      $carousel.owlCarousel({
        items: 3,
        nav: false,
        dots: false,
        loop: true,
        autoHeight: true,
        smartSpeed: 800,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsive: {
          0: {
            items: 1,
            margin: 30
          },
          1280: {
            items: 3,
            margin: 50
          }
        }
      });

      $floatNav.find('.owl-prev').on('click.brandReviews', function () {
        $carousel.trigger('prev.owl.carousel');
      });
      $floatNav.find('.owl-next').on('click.brandReviews', function () {
        $carousel.trigger('next.owl.carousel');
      });
    });
  }

  $(document).ready(function () {
    initBrandReviews(document);
  });

  $(document).on('shopify:section:load', function (event) {
    initBrandReviews(event.target);
  });
})(jQuery);
